import { useCallback } from "react";

import { useCommitChange, useField, useFieldContext, useFieldLabelAndDescription } from "../forms";
import type { ThemePalettePickerProps } from "./ThemePalettePicker";
import { ThemePalettePicker } from "./ThemePalettePicker";
import type { PlayerPalette } from "./types";

type Props = Omit<ThemePalettePickerProps, "onChange" | "value" | "helperText"> & {
  defaultPalette: PlayerPalette;
};

export const FieldThemePalettePicker = ({ defaultPalette, label, ...props }: Props) => {
  const commitChange = useCommitChange();

  const { name } = useFieldContext();
  const [{ value }, _, { setValue }] = useField(name);
  const [fieldLabel, helperText] = useFieldLabelAndDescription(name);

  const handleChange: ThemePalettePickerProps["onChange"] = useCallback(
    (newValue) => {
      void setValue(newValue);
    },
    [setValue],
  );

  const handleResetPalette: ThemePalettePickerProps["onResetToOriginalConfig"] = useCallback(() => {
    void setValue(defaultPalette);
  }, [defaultPalette, setValue]);

  return (
    <ThemePalettePicker
      {...props}
      id={name}
      helperText={helperText}
      label={label ?? fieldLabel}
      onChange={handleChange}
      onChangeCommitted={commitChange}
      value={value}
      onResetToOriginalConfig={handleResetPalette}
    />
  );
};
